/**
 * BookBlom — collection.js
 * <facet-filters>: Shopify storefront filtering + sorting without full page
 * reloads. The markup is a normal GET form, so it also works without JS.
 * Results are fetched with the Section Rendering API (?section_id=…).
 */
(function () {
  'use strict';

  var BB = (window.BB = window.BB || {});
  var ui = BB.ui;

  if (customElements.get('facet-filters')) return;

  customElements.define('facet-filters', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.sectionId = this.dataset.section;
      this.form = this.querySelector('form');
      this.drawer = this.querySelector('[data-facets-drawer]');
      this.cache = new Map();

      this.onInput = ui.debounce(() => this.submit(), 500);
      this.addEventListener('change', (e) => {
        if (e.target.matches('input[type="number"]')) return; // handled by input debounce
        this.submit();
      });
      this.addEventListener('input', (e) => {
        if (e.target.matches('input[type="number"]')) this.onInput();
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submit();
        this.closeDrawer();
      });
      this.addEventListener('click', (e) => {
        const remove = e.target.closest('[data-facet-remove]');
        if (remove) {
          e.preventDefault();
          this.load(new URL(remove.href, window.location.origin).search.slice(1));
          return;
        }
        if (e.target.closest('[data-facets-open]')) this.openDrawer(e.target.closest('[data-facets-open]'));
        if (e.target.closest('[data-facets-close]') && e.target.closest('[type="submit"]') === null) this.closeDrawer();
      });
      this.onKey = (e) => { if (e.key === 'Escape' && this.drawer && this.drawer.classList.contains('is-open')) this.closeDrawer(); };
      document.addEventListener('keydown', this.onKey);
      this.onPop = () => this.load(window.location.search.slice(1), false);
      window.addEventListener('popstate', this.onPop);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('popstate', this.onPop);
      this._bound = false;
    }

    params() {
      const fd = new FormData(this.form);
      const params = new URLSearchParams();
      for (const [key, value] of fd.entries()) {
        if (value !== '') params.append(key, value);
      }
      return params.toString();
    }

    submit() { this.load(this.params()); }

    load(query, push) {
      const base = this.form.getAttribute('action') || window.location.pathname;
      const url = base + '?' + query + (query ? '&' : '') + 'section_id=' + this.sectionId;
      const results = document.querySelector('#shopify-section-' + this.sectionId + ' [data-facet-results]');
      if (results) results.classList.add('is-loading');

      const render = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const swap = (sel) => {
          const fresh = doc.querySelector(sel);
          document.querySelectorAll('#shopify-section-' + this.sectionId + ' ' + sel).forEach((current) => {
            if (fresh) current.innerHTML = fresh.innerHTML;
          });
        };
        const focusedId = document.activeElement && document.activeElement.id;
        ['[data-facet-results]', '[data-facet-count]', '[data-facet-active]', '[data-facet-filters]', '.facets__footer'].forEach(swap);
        const badge = doc.querySelector('[data-facet-active-count]');
        const currentBadge = this.querySelector('[data-facet-active-count]');
        if (badge && currentBadge) { currentBadge.textContent = badge.textContent; currentBadge.hidden = badge.hidden; }
        if (focusedId) {
          const again = document.getElementById(focusedId);
          if (again) again.focus({ preventScroll: true });
        }
        if (results) results.classList.remove('is-loading');
        const newResults = document.querySelector('#shopify-section-' + this.sectionId + ' [data-facet-results]');
        if (BB.motion && newResults) BB.motion.initReveal(newResults);
      };

      if (this.cache.has(url)) render(this.cache.get(url));
      else {
        fetch(url)
          .then((r) => r.text())
          .then((html) => { this.cache.set(url, html); render(html); })
          .catch(() => { window.location.search = query; });
      }
      if (push !== false) {
        const pageUrl = window.location.pathname + (query ? '?' + query : '');
        window.history.pushState({ facets: query }, '', pageUrl);
      }
    }

    openDrawer(trigger) {
      if (!this.drawer) return;
      this.returnFocus = trigger;
      this.drawer.removeAttribute('inert');
      this.drawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => this.drawer.classList.add('is-open'));
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      ui.lockScroll();
      this.release = ui.trapFocus(this.drawer.querySelector('.drawer__panel'), this.drawer.querySelector('[data-facets-close].icon-btn'));
    }

    closeDrawer() {
      if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.drawer.setAttribute('inert', '');
      const trigger = this.querySelector('[data-facets-open]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      ui.unlockScroll();
      if (this.release) this.release();
      if (this.returnFocus) this.returnFocus.focus({ preventScroll: true });
    }
  });
})();
